var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMyCabin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MY_CABIN",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2505 368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2505,362h-93l-116-184.5v184.5h-93V12h91l118,195V12h93V362Zm-357,0h-92V12h92V362ZM1729,12h157.5c59.5,0,112.5,29,112.5,87.5,0,34.5-14,56.5-46.5,72.5,42.5,10.5,66.5,47.5,66.5,87,0,58.5-42.5,103-112.5,103h-177.5V12Zm129,135.5c26,0,40.5-13,40.5-31.5,0-16.5-13.5-29-37.5-29h-40.5v60.5h37.5Zm17.5,138c30,0,48-12.5,48-36.5,0-22.5-16.5-36.5-44.5-36.5h-58.5v73h55ZM1336.9985,0c35,10.5,79.5,12,117,12s80-1.5,115-12l142.5,362h-245.5l-84-233-84,233h-103.5L1336.9985,0Zm-472.5015,186.5c0-107,76-180.5,179.5-180.5,92.5,0,163.5,58,163.5,146h-93c0-38.5-30.5-64-71.5-64-45.5,0-84.5,31-84.5,95,0,69,41.5,98,89.5,98,39,0,66.5-19.5,85-52.5l76.5,44.5c-34.5,62-94.5,95-162,95-104.5,0-183-72.5-183-181.5ZM522.9985,12l63.5,143L641.9985,12h103l-150,350h-103.5l46-104.5L416.9985,12h106ZM0,12H128l70.5,225L269,12h128V362h-91.5V153l-70,209h-74L91.5,153v209H0V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyCabin);
export default __webpack_public_path__ + "static/media/Logo_MyCabin.c0669550.svg";
export { ForwardRef as ReactComponent };